import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ErrorBoundary from './components/ErrorBoundary';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import './styles/mipt-theme.css';

const TaskSpace = lazy(() => import('./pages/TaskSpace'));
const TopicPage = lazy(() => import('./pages/TopicPage'));
const Workspace = lazy(() => import('./pages/Workspace'));
const MathLibExplorer = lazy(() => import('./pages/MathLibExplorer'));
const MathLibDetail = lazy(() => import('./pages/MathLibDetail'));
const ErrorDetectionPage = lazy(() => import('./pages/ErrorDetectionPage'));
const LabPage = lazy(() => import('./pages/LabPage'));
const CoursePage = lazy(() => import('./pages/CoursePage'));
const LectureDetail = lazy(() => import('./pages/LectureDetail'));
const HomeworkPage = lazy(() => import('./pages/HomeworkPage'));
const HomeworkDetail = lazy(() => import('./pages/HomeworkDetail'));
const MySpace = lazy(() => import('./pages/MySpace'));
const StandupPage = lazy(() => import('./pages/StandupPage'));
const ArchivePage = lazy(() => import('./pages/ArchivePage'));
const About = lazy(() => import('./pages/About'));

function Loading() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <div className="skeleton" style={{ height: 200, maxWidth: 600, margin: '0 auto' }} />
    </div>
  );
}

/** До входа показываем только форму логина: API всё равно закрыт для анонимов. */
function Shell() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <LoginPage />;
  if (user.must_change_password) return <ChangePasswordPage />;

  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <main style={{ flex: 1 }}>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<TaskSpace />} />
          <Route path="/topic/:id" element={<TopicPage />} />
          <Route path="/workspace/:taskId" element={<Workspace />} />
          <Route path="/course" element={<CoursePage />} />
          <Route path="/course/:number" element={<LectureDetail />} />
          <Route path="/homework" element={<HomeworkPage />} />
          <Route path="/homework/:number" element={<HomeworkDetail />} />
          <Route path="/errors" element={<ErrorDetectionPage />} />
          <Route path="/lab" element={<LabPage />} />
          <Route path="/explorer" element={<MathLibExplorer />} />
          <Route path="/explorer/:id" element={<MathLibDetail />} />
          <Route path="/standup" element={<StandupPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/me" element={<MySpace />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </Suspense>
      </main>
      <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <ErrorBoundary label="Приложение">
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
